import { Injectable, inject } from '@angular/core';
import { MessageService } from 'primeng/api';

export interface ToastMessage {
  severity: 'success' | 'info' | 'warn' | 'error';
  summary: string;
  detail?: string;
  life?: number;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private messageService = inject(MessageService);

  success(summary: string, detail?: string): void {
    this.addMessage('success', summary, detail);
  }

  info(summary: string, detail?: string): void {
    this.addMessage('info', summary, detail);
  }

  warn(summary: string, detail?: string): void {
    this.addMessage('warn', summary, detail);
  }

  error(summary: string, detail?: string): void {
    this.addMessage('error', summary, detail);
  }

  private addMessage(severity: 'success' | 'info' | 'warn' | 'error', summary: string, detail?: string): void {
    this.messageService.add({ 
      severity, 
      summary, 
      detail, 
      life: 5000, 
      closable: true 
    });
  }
}
